const deleteEquipmentModelsStr = {
  toastr: 'Tipo de Equipamento deletado',
  toastr1: ' deletado com sucesso'
};

export default deleteEquipmentModelsStr;
